import { SET_STORED_TABLE_STATE, RESET_STORED_TABLE_STATES, CLEAR_STORED_TABLE_STATE } from './types'

export const setStoredTableState = tableState => dispatch => {
	dispatch({
		type: SET_STORED_TABLE_STATE,
		payload: tableState
	})
}

export const clearStoredTableState = tableKey => dispatch => {
	dispatch({
		type: CLEAR_STORED_TABLE_STATE,
		payload: tableKey
	})
}

export const resetStoredTableStates = () => dispatch => {
	dispatch({
		type: RESET_STORED_TABLE_STATES
	})
}